export function isMobile() {
    const userAgent = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
    );
    const screenWidth = window.innerWidth <= 768;
    return userAgent || screenWidth;
}

export function loadView(desktopImport, mobileImport) {
    return isMobile() ? mobileImport : desktopImport;
}